export const getMoviesSaga = 'GET_MOVIES_SAGA';
export const searchMoviesSaga = 'SEARCH_MOVIES_SAGA';
export const receiveMovies = 'RECEIVE_MOVIES';
export const receiveSearchMovieResults = 'RECEIVE_SEARCH_MOVIE_RESULTS';
export const getTmdbConfigurationSaga = 'GET_TMDB_CONFIGURATION_SAGA';
export const receiveTmdbConfiguration = 'RECEIVE_TMDB_CONFIGURATION';